import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="relative bg-zi-tint2 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-zi-accent">
            In their words
          </p>
          <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-zi-ink sm:text-5xl lg:text-6xl">
            Trusted by growing businesses.
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              className="flex flex-col justify-between rounded-3xl border border-zi-line bg-white p-8 shadow-sm"
            >
              <div>
                <div className="flex items-center gap-1 text-zi-accent">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={16} className="fill-zi-accent" />
                  ))}
                </div>
                <Quote className="mt-5 text-zi-primary/40" size={30} />
                <blockquote className="mt-3 font-heading text-lg leading-relaxed text-zi-ink">
                  "{t.quote}"
                </blockquote>
              </div>
              <figcaption className="mt-7 border-t border-zi-line pt-5 font-heading text-base font-bold text-zi-ink">
                {t.name}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
